import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

import {version} from '../../package'

const bugsnagClient = bugsnag({apiKey: 'e5c1d84832405f4f6bd29399938938e0',  appVersion: version });

if (process.env.NODE_ENV === 'production') {
  bugsnagClient.use(bugsnagVue, Vue);
}

export default bugsnagClient
